export enum OpenStockFrom {
  remision = 1,
  factura = 2,
  service = 3,
  salidaSubalquiler = 4,
  trasladoAlmacenTaller = 5,
  trasladoTallerAlmacen = 6,
  pedidos = 7,
}